import React from 'react';
import { FaClock, FaBullseye, FaUserFriends, FaMedal, FaArrowRight } from 'react-icons/fa';

const features = [
  {
    icon: <FaClock size={28} color="#3b5bdb" />,
    title: 'Flexible Entry',
    description: 'Join any time during your academic journey or after graduation',
  },
  {
    icon: <FaBullseye size={28} color="#ae3ec9" />,
    title: 'Personalized Roadmap',
    description: 'Custom training path based on your background and career goals',
  },
  {
    icon: <FaUserFriends size={28} color="#2f9e44" />,
    title: 'Industry Mentors',
    description: 'Learn directly from working professionals in your field',
  },
  {
    icon: <FaMedal size={28} color="#fd7e14" />,
    title: 'Job Guarantee',
    description: '95% placement rate with salary assurance programs',
  },
];

const WhyChooseTraining = ({ onStartClick }) => {
  return (
    <div className="j-why-choose-training bg-white text-center py-5">
      <div className="container">
        <h2 className="fw-bold mb-2">Why Choose Campus To Corporate Training?</h2>
        <p className="text-muted mb-5">
          Personalized learning experience designed around your schedule and career goals
        </p>

        <div className="row g-4 mb-5">
          {features.map((feature, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div className="bg-light rounded-4 p-4 h-100 shadow-sm j-feature-card">
                <div className="mb-3">{feature.icon}</div>
                <h6 className="fw-bold mb-2">{feature.title}</h6>
                <p className="text-muted small mb-0">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <button
          className="btn j-btn-start-journey rounded  fw-semibold text-white"
          onClick={onStartClick}
        >
          Start Your Journey Today <FaArrowRight className="ms-2" />
        </button>
      </div>
    </div>
  );
};

export default WhyChooseTraining;
